"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "28", height: "22", viewBox: "0 0 28 22", className: "Icon toolbar-image-preview", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#E3E3E3", d: "M0 0h28v22H0z" }),
            _react2.default.createElement("path", { d: "M0 0h28v22H0z" }),
            _react2.default.createElement("path", { d: "M0 0h28v22H0z" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M9.5 9L19 22H0z" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M22 15l6 7H16z" }),
            _react2.default.createElement("path", { d: "M21.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z", fill: "#FFF" }),
            _react2.default.createElement("path", { stroke: "#BBB", d: "M.5.5h27v21H.5z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-image-preview.js
// module id = 1884
// module chunks = 0